import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=1bbdbfae&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"
import style0 from "./empty.vue?vue&type=style&index=0&id=1bbdbfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdbfae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme3DesktopNavBar: require('/app/components/Theme3/Desktop/NavBar.vue').default,Theme3MobileNavBar: require('/app/components/Theme3/Mobile/NavBar.vue').default,CommonsChangeLanguageLoading: require('/app/components/Commons/ChangeLanguageLoading.vue').default})
